import { render, staticRenderFns } from "./DOTSVisitDateRemark.vue?vue&type=template&id=d77c0e52&scoped=true"
import script from "./DOTSVisitDateRemark.vue?vue&type=script&lang=js"
export * from "./DOTSVisitDateRemark.vue?vue&type=script&lang=js"
import style0 from "./DOTSVisitDateRemark.vue?vue&type=style&index=0&id=d77c0e52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d77c0e52",
  null
  
)

export default component.exports